export default __webpack_public_path__ + "static/media/student-housing.5a535266.png";